/* =========================================================
   PlayPulse RC · Blog Collection Page
   assets/pp-blog.js
   Banner carousel + category pill horizontal-scroll hint
   =========================================================
   v2 · 服务端分页版
   分类筛选与分页已改由 Shopify 服务端完成（真链接 + {% paginate %}），
   本文件不再做客户端过滤。只保留：
     01 Banner 轮播
     02 分类胶囊移动端横滑的边缘渐隐提示
   ========================================================= */
(function () {
  'use strict';

  /* ---------------------------------------------------------
     01 · BANNER CAROUSEL
     --------------------------------------------------------- */
  function initBanner() {
    var banner = document.getElementById('ppBanner');
    if (!banner) return;

    var slides = banner.querySelectorAll('.pp-slide');
    if (slides.length === 0) return;

    var dotsBox  = banner.querySelector('#ppDots');
    var prevBtn  = banner.querySelector('#ppPrev');
    var nextBtn  = banner.querySelector('#ppNext');
    var autoplay = banner.dataset.autoplay === 'true';
    var interval = parseInt(banner.dataset.interval, 10) || 5500;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) autoplay = false;

    /* single slide → no controls needed */
    if (slides.length < 2) {
      if (prevBtn) prevBtn.hidden = true;
      if (nextBtn) nextBtn.hidden = true;
      if (dotsBox) dotsBox.hidden = true;
      return;
    }

    var cur = 0, timer = null;

    /* build dots */
    if (dotsBox) {
      slides.forEach(function (_, i) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'pp-dot' + (i === 0 ? ' is-active' : '');
        d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        d.addEventListener('click', function () { go(i); });
        dotsBox.appendChild(d);
      });
    }
    var dots = dotsBox ? dotsBox.querySelectorAll('.pp-dot') : [];

    function go(i) {
      slides[cur].classList.remove('is-active');
      if (dots[cur]) dots[cur].classList.remove('is-active');

      cur = (i + slides.length) % slides.length;

      slides[cur].classList.add('is-active');
      if (dots[cur]) dots[cur].classList.add('is-active');

      restart();
    }

    function restart() {
      if (!autoplay) return;
      clearInterval(timer);
      timer = setInterval(function () { go(cur + 1); }, interval);
    }

    function stop() { clearInterval(timer); }

    if (prevBtn) prevBtn.addEventListener('click', function () { go(cur - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(cur + 1); });

    banner.addEventListener('mouseenter', stop);
    banner.addEventListener('mouseleave', restart);

    /* keyboard support */
    banner.setAttribute('tabindex', '0');
    banner.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft')  { go(cur - 1); }
      if (e.key === 'ArrowRight') { go(cur + 1); }
    });

    /* touch swipe */
    var startX = 0;
    banner.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    banner.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 45) { go(dx < 0 ? cur + 1 : cur - 1); }
    }, { passive: true });

    /* fullscreen support */
    initFullscreen(banner);

    restart();
  }

  /* ---------------------------------------------------------
     01b · BANNER FULLSCREEN
     优先使用浏览器原生 Fullscreen API；若浏览器不支持（部分 iOS
     Safari），退化为「伪全屏」——只加 is-full 类，用 fixed 铺满视口，
     观感一致，用户按 Esc 或再点一次按钮即可退出。
     --------------------------------------------------------- */
  function initFullscreen(banner) {
    var btn = banner.querySelector('#ppFullscreen');
    if (!btn) return;

    var doc = document;
    var root = doc.documentElement;
    var fake = false;   /* 是否处于降级（伪全屏）模式 */

    function fsElement() {
      return doc.fullscreenElement || doc.webkitFullscreenElement ||
             doc.mozFullScreenElement || doc.msFullscreenElement || null;
    }

    function requestFs(el) {
      var fn = el.requestFullscreen || el.webkitRequestFullscreen ||
               el.mozRequestFullScreen || el.msRequestFullscreen;
      if (!fn) return null;
      try {
        var ret = fn.call(el);
        /* 有些浏览器返回 undefined 而不是 Promise */
        return (ret && typeof ret.then === 'function') ? ret : null;
      } catch (err) {
        return null;
      }
    }

    function exitFs() {
      var fn = doc.exitFullscreen || doc.webkitExitFullscreen ||
               doc.mozCancelFullScreen || doc.msExitFullscreen;
      if (!fn) return null;
      try {
        var ret = fn.call(doc);
        return (ret && typeof ret.then === 'function') ? ret : null;
      } catch (err) {
        return null;
      }
    }

    /* 同步按钮图标 + 页面滚动锁 + body 类名 */
    function paint(on) {
      btn.classList.toggle('is-on', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      banner.classList.toggle('is-full', on);
      doc.body.classList.toggle('pp-fs-open-body', on);
      /* 原生全屏时浏览器自身处理尺寸，伪全屏靠 CSS 铺满 */
    }

    function isOn() {
      return fake ? banner.classList.contains('is-full') : !!fsElement();
    }

    function enter() {
      var p = requestFs(banner);
      if (p) {
        p.then(function () { fake = false; paint(true); })
         .catch(function () { fake = true; paint(true); });
      } else if (p === null) {
        /* requestFs 返回 null 有两种可能：API 不存在，或调用抛错。
           统一走伪全屏，保证按钮永远有反应。 */
        fake = true;
        paint(true);
      } else {
        /* 返回了 undefined（无 Promise 的老实现），乐观进入，交给
           fullscreenchange 事件来校准真实状态 */
        fake = false;
        paint(true);
      }
    }

    function leave() {
      if (fake) {
        fake = false;
        paint(false);
        return;
      }
      var p = exitFs();
      if (p) {
        p.then(function () { paint(false); })
         .catch(function () { paint(false); });
      } else {
        paint(false);
      }
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();     /* 别让轮播的键盘/触摸逻辑抢事件 */
      if (isOn()) { leave(); } else { enter(); }
    });

    /* 用户按 Esc 或用系统按钮退出时，回写按钮状态 */
    ['fullscreenchange', 'webkitfullscreenchange',
     'mozfullscreenchange', 'MSFullscreenChange'].forEach(function (evt) {
      doc.addEventListener(evt, function () {
        if (fake) return;                       /* 伪全屏不响应原生事件 */
        paint(!!fsElement());
      });
    });

    /* 伪全屏时用 Esc 退出 */
    doc.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && fake) { leave(); }
    });
  }

  /* ---------------------------------------------------------
     02 · PILL STRIP · 横滑边缘提示
     胶囊现在是「真链接」，筛选由服务端完成，这里只做体验增强：
     当这一行可以左右滑动时，给容器加 is-scrollable / is-at-start /
     is-at-end 三个状态类，CSS 据此显示边缘渐隐，提示「还能滑」。
     --------------------------------------------------------- */
  function initPillStrip() {
    var strip = document.getElementById('ppPills');
    if (!strip) return;

    function sync() {
      var maxScroll = strip.scrollWidth - strip.clientWidth;

      /* 内容没超出（桌面端换行）→ 不需要提示 */
      if (maxScroll <= 2) {
        strip.classList.remove('is-scrollable', 'is-at-start', 'is-at-end');
        return;
      }
      strip.classList.add('is-scrollable');
      strip.classList.toggle('is-at-start', strip.scrollLeft <= 2);
      strip.classList.toggle('is-at-end', strip.scrollLeft >= maxScroll - 2);
    }

    sync();
    strip.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);

    /* 把当前选中的胶囊滑进视野，避免用户点进分类后看不到高亮项 */
    var active = strip.querySelector('.pp-pill.is-active');
    if (active && strip.scrollWidth > strip.clientWidth) {
      var left = active.offsetLeft - strip.clientWidth / 2 + active.offsetWidth / 2;
      strip.scrollLeft = Math.max(0, left);
      sync();
    }
  }

  /* ---------------------------------------------------------
     BOOT
     --------------------------------------------------------- */
  function boot() {
    initBanner();
    initPillStrip();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
